import * as debounce from 'debounce';
const send_analog_output_value = async (api, device_id, object_id, value, request_time) => {
    try {
        await api.send_z3k_command(device_id, {
            object_id,
            command_name: 'ChangeWebElementState',
            command_args: { state: 2, value: value },
        }, false, request_time);
    }
    catch (error) {
        const { json } = error;
        return console.log(json);
    }
};
const _debounced_cache = {};
const get_debounced_send_for = (device_id, object_id) => {
    const cache_key = `${device_id}:${object_id}`;
    const existing = _debounced_cache[cache_key];
    if (existing != null)
        return existing;
    return (_debounced_cache[cache_key] = debounce(send_analog_output_value, 1000));
};
export const setZ3kAnalogOutputValue = (device_id, object_id, value) => (dispatch, getState, { api }) => {
    const request_time = new Date().getTime();
    const action = {
        type: 'SET_Z3K_ANALOG_OUTPUT_VALUE',
        device_id,
        object_id,
        value,
        request_time,
    };
    dispatch(action);
    get_debounced_send_for(device_id, object_id)(api, device_id, object_id, value, request_time);
};
